import { combineReducers } from 'redux';

import fetchCustomPageMap, {
    fetchShuttleGuideAction,
} from './actions/fetchAirportShuttlesGuide';
import shuttleGuideReducerMap, {
    selectors as shuttleGuideSelectors,
} from './appstate';
import namespace from './types';

const reducer = combineReducers({
    ...fetchCustomPageMap,
    ...shuttleGuideReducerMap,
});

export {
    fetchShuttleGuideAction,
    shuttleGuideSelectors,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    [namespace]: reducer,
};
